import React, { useContext, useMemo, useState } from 'react'
import { useGetPermissions } from 'layouts/customHook';
import { checkPermission } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import ApprovalSentSuccessDialog from 'views/pages/manage/unAssigned/examCharges/examChargesDetails/dialogs/ApprovalSentSuccessDialog';
import { generateProgressSteps } from 'modules/studentView/constant';
import BmApprovalAction from './BmApprovalAction';

import { getProgressStepList } from './constant';
import TransferTimeline from 'modules/studentView/progressTimeLine';
import { UserDetails } from 'appContext';
import { useNavigateToGivenPath } from "views/pages/manage/edpOps/studentDetails/paymentSummary/service";

const ProgressAndActionsWrapper = ({ data }) => {

    const {
        dropdowns,
        depositSlipNo,
        getDetails,
        details,
        setLoading,
        isBmApproval,
        updateStatus,
        updateStatusInfo,
        setUpdateStatusInfo,
        approvalActionSuccessDialogInfo,
        setApprovalActionSuccessDialogInfo,
        approvalRequests,
        businessAreaValue,
        depositSlipId
    } = data;

    const userPermissions = useGetPermissions("cashManagementApproval");
    const isApproverPermission = checkPermission(userPermissions, "A");
    const userDetails = useContext(UserDetails);
    const navigate = useNavigateToGivenPath();

    const isApproval = useMemo(() => {
        if (!approvalRequests || approvalRequests.length === 0) return false;

        const {
            approvalStatus,
            isL1Approver,
            isL2Approver,
            isL3Approver
        } = approvalRequests;

        const isL1Pending = approvalStatus === 'L1_PENDING';
        const isL2Pending = approvalStatus === 'L2_PENDING';
        const isL3Pending = approvalStatus === 'L3_PENDING';

        return (
            (isL1Pending && isL1Approver) ||
            (isL2Pending && isL2Approver) ||
            (isL3Pending && isL3Approver)
        );
    }, [approvalRequests]);

    const logs = useMemo(() => {
        return (details?.logs?.depositSlipDetailsAuditDTOList || []).map(item => ({
            ...item,
            title: item?.action,
        }));
    }, [details?.logs?.depositSlipDetailsAuditDTOList]);
    const onEditReceipt = () => {
    navigate(
      `/admin/cash-management/editCashDeposit/${businessAreaValue}/${depositSlipId}?depositSlipId=${encodeURIComponent(depositSlipNo)}`
    );
  };


    const steps = generateProgressSteps(getProgressStepList(details?.logs?.approverCount,onEditReceipt), logs);

    const bmApprovalActionsProps = {
        updateStatus,
        setLoader: setLoading,
        userDetails,
        depositSlipNo,
        approvalRequests,
        updateStatusInfo,
        setUpdateStatusInfo
    }


    return (
        <div>
            {
                isApproval &&
                isApproverPermission &&
                <BmApprovalAction data={bmApprovalActionsProps} />}
            <TransferTimeline
                steps={steps}
                heading='Payment management status'
            />
            {/* <ApprovalSentSuccessDialog
                open={approvalActionSuccessDialogInfo}
                setOpen={setApprovalActionSuccessDialogInfo}
                heading={approvalActionSuccessDialogInfo?.heading}
                subHeading={approvalActionSuccessDialogInfo?.subHeading}
                closeCb={() => { getDetails() }}
            /> */}
        </div>
    )
}

export default ProgressAndActionsWrapper;